import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import LazyVideo from "@/components/LazyVideo";
import heroBgVideo from "@/assets/hero-bg-video.mp4";

const HomeHero = () => (
  <section className="relative overflow-hidden" id="hero">
    <div className="absolute inset-0 z-0" aria-hidden="true">
      <LazyVideo src={heroBgVideo} eager />
      <div className="absolute inset-0 bg-primary/95" />
    </div>

    <div className="relative z-10 section-padding pt-28 md:pt-36 lg:pt-44">
      <div className="container-narrow text-center max-w-3xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="heading-xl text-primary-foreground">
            Website refresh for service businesses.
            <br />
            <span className="text-accent">Built to perform.</span>
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-primary-foreground/70 md:text-xl max-w-2xl mx-auto">
            We refresh outdated contractor, law firm, and clinic websites into fast, lead-generating sites - without the cost and chaos of a full redesign. Fixed pricing, 14-day turnaround, SEO preserved.
          </p>
          <p className="mt-4 text-sm font-semibold uppercase tracking-widest text-primary-foreground/40">
            Live preview in days · Clear scope · Transparent pricing
          </p>
          <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">
            <Button variant="hero" size="lg" asChild>
              <Link to="/apply">Get a Free Homepage Preview</Link>
            </Button>
            <Button
              variant="hero-outline"
              size="lg"
              className="border-primary-foreground/30 text-primary-foreground hover:border-accent hover:text-accent"
              asChild
            >
              <Link to="/pricing">See Our Pricing</Link>
            </Button>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs sm:text-sm text-primary-foreground/70">
            <span className="flex items-center gap-1.5">
              <span className="text-accent" aria-hidden="true">★</span>
              Trusted by 50+ service businesses
            </span>
            <span className="text-primary-foreground/30" aria-hidden="true">·</span>
            <span>14-day delivery</span>
            <span className="text-primary-foreground/30" aria-hidden="true">·</span>
            <span>Fixed pricing</span>
            <span className="text-primary-foreground/30" aria-hidden="true">·</span>
            <span>SEO preserved</span>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
          className="mt-16 flex justify-center"
        >
          <a href="#proof" className="group flex flex-col items-center gap-1">
            <span className="text-xs uppercase tracking-widest text-primary-foreground/30">Scroll</span>
            <ChevronDown className="h-5 w-5 text-primary-foreground/30 animate-bounce" />
          </a>
        </motion.div>
      </div>
    </div>
  </section>
);

export default HomeHero;